import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-core-api/v1.0.0/',
  ssoApiProxyUrl: 'https://uhcinsights.uhc.com/',
  postLoginProxyUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-core-api/v1.0.0/',
  originUrl: '/',
  redirectUri: 'https://uhcinsights.uhc.com/',
  ohidApiProxyUrl: 'https://uhcinsights.uhc.com/',
  ohidredirectUri: 'https://uhcinsights.uhc.com/login',
  externalEnvironment: 'https://uhcinsights.uhc.com/login',
  goldCardApi: 'https://api.uhg.com/api/pdr/msr/uhci-aws-goldcard-api/v1.0.0/',
  domain: '.uhc.com',
  domainEnvironment: ['https://uhcinsights.uhc.com'],
  cookieEnvironment: '',
  featureFlagUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-pnb-api/v1.0.0/pnb/feature-flags/',
  upstreamEnv: 'prod',
  goldCardEnvironment: 'prod',
  goldCardabyssparcelUrl: 'https://uhcinsights.uhc.com/abyss-parcel.js',
  qualtricksEnvCheck: 'prod',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-EN62cebcdf8f9040658ffce30131f73259.min.js',
  production: true,
  staging: false,
  noPROD: false,
  internalAccess: false,
  internalSsoLogin: false,
  XSRFToggle: false,
  qualtrics: true,
  goldCardFeatureToggle: 'true',
  tinLevelExternalChange: true,
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-bulk-process-api/v1.0.0/',
    SsoRedirectUri:
      'https://sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhcinsights.uhc.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectUriWithOutPrompt:
      'https://identity.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code' +
      '&redirect_uri=https://uhcinsights.uhc.com/login&scope=openid+profile+email&state=PED',
    SsoRedirectLogin:
      'https://identity.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code&' +
      'redirect_uri=https://uhcinsights.uhc.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://identity.onehealthcareid.com/oidc/logout?id_token_hint=id_token_hint_delimiter' +
      '&post_logout_redirect_uri=https://www.uhcprovider.com/&state=logout',
    linkLoginPage: 'https://provider.linkhealth.com',
    providerLoginPage: 'https://secure.uhcprovider.com/'
  },
};
